var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWifi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1180.5 162.402c1.306 0 2.562.524 3.508 1.464.072.072.186.071.256-.002l.68-.718c.036-.038.056-.088.056-.141 0-.053-.02-.103-.057-.14-2.484-2.487-6.402-2.487-8.886 0-.036.037-.057.087-.057.14 0 .053.02.103.055.14l.681.719c.07.074.185.075.256.002.946-.94 2.202-1.464 3.508-1.464zm0 2.336c.718 0 1.41.279 1.941.782.072.071.186.07.256-.004l.68-.718c.036-.037.056-.089.055-.142 0-.053-.021-.103-.058-.14-1.62-1.574-4.127-1.574-5.747 0-.036.037-.057.087-.058.14 0 .054.02.105.056.142l.68.718c.07.074.184.075.255.004.532-.503 1.223-.781 1.94-.782zm1.308 1.714c.036-.037.056-.088.055-.142 0-.053-.023-.103-.06-.14-.752-.663-1.853-.663-2.605 0-.038.037-.06.087-.06.14-.002.054.018.105.054.142l1.178 1.241c.034.036.081.057.13.057.05 0 .096-.02.13-.057l1.178-1.24z",
    transform: "translate(-1176 -161)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.853111a0.svg";
export { ForwardRef as ReactComponent };